export type Category = {
  clss: string
  base: string
  size: string
  prod: string
  topp: string
}

export const categoryValues = {
  clss: 'class',
  base: 'base',
  size: 'size',
  prod: 'prod',
  topp: 'options',
}

export type CategoryKey = keyof Category;